//@flow
import React, { Fragment } from 'react';
import browserHistory from '../../../utils/history';
import UrlData from '../../Utils/url-data';
import formUtils from '../../Utils/form';
import CustomerApiInterface from '../../APIInterfaces/customer';

type Props = {
  heroVersion?:boolean,
};

type State = {
  isSubmitting:boolean,
};

const SUPPORT_EMAIL = 'support@naturebox.com';

const FORM_FIELDS = [
  "employee_range",
  "first_name",
  "last_name",
  "company",
  "email",
  "phone",
  "location_state",
];

// WARNING: do not change employee range options
// as they are used by third-party integrations (e.g. Zapier)
// for lead handling
const EMPLOYEE_RANGE_OPTIONS = [
  {value: "", label: "Number of employees"},
  {value: "Less than 20", label: "Less than 20"},
  {value: "20-50", label: "20-50"},
  {value: "51-100", label: "51-100"},
  {value: "101-200", label: "101-200"},
  {value: "201-500", label: "201-500"},
  {value: "More than 500", label: "More than 500"},
];

const emailPattern = formUtils.getWorkEmailPattern();

function _renderStateSelect() {
  return (
    <select className="small-3 columns location-state" id="location_state" name="location_state" title="State" required={true}>
      <option value="">State</option>
      { STATES.map(item => <option key={item} value={`${item}`}>{item}</option>) }
    </select>
  );
}

function _setCustomInvalidMessage(event) {
  const errorMessage = "Work email required. Questions? Contact sales@naturebox.com";
  event.target.setCustomValidity(errorMessage);
}
function _resetCustomValidity(event) {
  event.target.setCustomValidity('');
}

function _renderUserForm(state) {
  return (
    <Fragment>
      <div className="row">
        <input className="small-6 columns firstname" id="first_name" maxLength="40" name="first_name" size="20" type="text" placeholder="First name" required={true}/>
        <input className="small-6 columns lastname" id="last_name" maxLength="80" name="last_name" size="20" type="text" placeholder="Last name" required={true}/>
      </div>
      <div className="row">
        <input id="email" maxLength="80" name="email" size="20" type="text" placeholder="Work email address" required={true} onInput={_resetCustomValidity} onInvalid={_setCustomInvalidMessage} pattern={emailPattern}/>
      </div>
      <div className="row">
        <input id="company" maxLength="40" name="company" size="20" type="text" placeholder="Company name" required={true}/>
      </div>
      <div className="row">
        <input className="small-9 columns phone" id="phone" maxLength="12" name="phone" size="20" type="text" placeholder="Phone number" required={true}/>
        {_renderStateSelect()}
      </div>
      <div className="row">
        <input type="submit" name="submit" value="Get a free sample" id="ss-submit" disabled={state.isSubmitting} />
      </div>

      <div className="divider text-4"><hr/> or <hr/></div>
      <div className="schedule-call">
        <a
          className="cta-secondary-color"
          href="https://calendly.com/naturebox/naturebox-demo"
        >
          Schedule a call to learn more
        </a>
      </div>
    </Fragment>
  );
}

function _renderHeader(props:Props) {
  if (props.heroVersion) {
    return (
      <Fragment>
        <h1 id="office-form">Unlimited snacks to fuel your hungry team!</h1>
        <p className="text-2">All you can eat snacks for one predictable monthly price!</p>
      </Fragment>
    );
  }

  return (
    <h1 id="office-form">Get started today!</h1>
  );
}

export default class OfficeForm extends React.PureComponent<Props, State> {
  state = { isSubmitting: false };
  unlisten:?()=>void;
  mainDiv:?HTMLElement;

  saveMainDiv = (div:?React$ElementRef<'div'>) => {
    this.mainDiv = div;
  };

  _scrollIfNecessary = () => {
    if (UrlData.getHash() === '#office-form') {
      this.mainDiv && this.mainDiv.scrollIntoView();
    }
  }

  componentDidMount() {
    this._scrollIfNecessary();

    // listen for any page changes that don't cause a reload
    this.unlisten = browserHistory.listen(this._scrollIfNecessary);
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  handleSubmit = (event:any) => {
    event.preventDefault();

    this.setState({isSubmitting: true});

    const values = {};

    FORM_FIELDS.forEach(key => values[key] = event.target.elements[key].value);

    const successUrl = values.employee_range === "Less than 20"
      ? "/office/thanks-less-than-20"
      : "/office/thanks";

    return CustomerApiInterface.submitOfficeForm(values)
      .then(() => {
        browserHistory.push(successUrl);
        return true;
      })
      .catch(() => {
        this.setState({isSubmitting: false});
        const msg = `Sorry, we were unable to complete the request. Please contact us directly at ${SUPPORT_EMAIL}.`;
        window.alert(msg);
      });
  }

  render() {
    return (
      <div className="office-form" ref={this.saveMainDiv}>
        <div className="office-input-form">
          {_renderHeader(this.props)}

          <div className="inbound-form">
            <form
              className="formsy-form"
              onSubmit={this.handleSubmit}
            >
              <div className="row">
                <select id="employee_range" name="employee_range" title="Employee Range" required={true}>
                  {EMPLOYEE_RANGE_OPTIONS.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {_renderUserForm(this.state)}
            </form>
          </div>
        </div>

        <div className="office-form-img"></div>
      </div>
    );
  }
}

const STATES = [
  'AL','AK','AZ','AR','CA','CO','CT',
  'DE','DC','FL','GA','GU','HI','ID',
  'IL','IN','IA','KS','KY','LA','ME',
  'MD','MA','MI','MN','MS','MO','MT',
  'NE','NV','NH','NJ','NM','NY','NC',
  'ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA',
  'WV','WI','WY',
];
